import { Avatar } from '@radix-ui/themes';
import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Header.css';

interface HeaderProps {
    onLogout: () => void;
}

const Header: React.FC<HeaderProps> = ({ onLogout }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const [catalogFile, setCatalogFile] = useState<string | null>(null);
    const navigate = useNavigate();

    // Close menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                setIsMenuOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const fetchCatalog = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/api/catalog`);
                if (response.ok) {
                    const data = await response.json();
                    setCatalogFile(data.file_path);
                }
            } catch (error) {
                console.error('Error fetching catalog:', error);
            }
        };
        
        fetchCatalog();
    }, []);

    // Handler to close menu
    const handleMenuItemClick = () => {
        setIsMenuOpen(false);
    };

    // Combined handler for logout
    const handleLogout = () => {
        setIsMenuOpen(false);  // Close menu
        onLogout();           // Call the logout function
    };

    return (
        <div id="header">
            <div className="header-profile-menu menu" ref={menuRef}>
                <div id="profile-menu-avatar" style={{float: 'right', position: 'relative'}}>
                    <div onClick={() => setIsMenuOpen(!isMenuOpen)} style={{cursor: 'pointer'}}>
                        <Avatar
                            size="3"
                            radius="full"
                            fallback={`${user.firstname?.[0] || ''} ${user.lastname?.[0] || ''}`}
                            color="gray"
                            highContrast
                            src={`https://api.dicebear.com/7.x/initials/svg?seed=${user.firstname?.[0] || ''} ${user.lastname?.[0] || ''}&backgroundColor=dddddd&textColor=999999`}
                        />
                    </div>
                    
                    {isMenuOpen && (
                        <div className="dropdown-menu" style={{
                            position: 'absolute',
                            top: '100%',
                            right: 0,
                            backgroundColor: 'white',
                            boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                            borderRadius: '4px',
                            padding: '8px 0',
                            minWidth: '250px',
                            zIndex: 1000
                        }}>
                            {!user.is_admin && (
                                <div>
                                    <Link 
                                        to="/lessons" 
                                        onClick={handleMenuItemClick}  // Add click handler
                                        style={{
                                            display: 'block',
                                            padding: '8px 16px',
                                            textDecoration: 'none',
                                            color: 'black'
                                        }}
                                    >
                                        หน้าแรก
                                    </Link>
                                    <Link 
                                        to="/profile" 
                                        onClick={handleMenuItemClick}  // Add click handler
                                        style={{
                                            display: 'block',
                                            padding: '8px 16px',
                                            textDecoration: 'none',
                                            color: 'black'
                                        }}
                                    >
                                        ข้อมูลส่วนตัว
                                    </Link>
                                    <Link 
                                        to="/progress" 
                                        onClick={handleMenuItemClick}  // Add click handler
                                        style={{
                                            display: 'block',
                                            padding: '8px 16px',
                                            textDecoration: 'none',
                                            color: 'black'
                                        }}
                                    >
                                        ความคืบหน้าในการเรียน
                                    </Link>
                                    <Link 
                                        to="/lessons" 
                                        onClick={handleMenuItemClick}  // Add click handler
                                        style={{
                                            display: 'block',
                                            padding: '8px 16px',
                                            textDecoration: 'none',
                                            color: 'black'
                                        }}
                                    >
                                        บทเรียน
                                    </Link>
                                </div>
                            )}
                            {user.is_admin && (
                                <div>
                                    <Link 
                                        to="/backend/lessons" 
                                        onClick={handleMenuItemClick}  // Add click handler
                                        style={{
                                            display: 'block',
                                            padding: '8px 16px',
                                            textDecoration: 'none',
                                            color: 'black'
                                        }}
                                    >
                                        หน้าแรก
                                    </Link>
                                    <Link 
                                        to="/backend/users" 
                                        onClick={handleMenuItemClick}  // Add click handler
                                        style={{
                                            display: 'block',
                                            padding: '8px 16px',
                                            textDecoration: 'none',
                                            color: 'black'
                                        }}
                                    >
                                        จัดการรหัสผ่านพนักงาน
                                    </Link>
                                    <Link 
                                        to="/backend/progress" 
                                        onClick={handleMenuItemClick}  // Add click handler
                                        style={{
                                            display: 'block',
                                            padding: '8px 16px',
                                            textDecoration: 'none',
                                            color: 'black'
                                        }}
                                    >
                                        ความคืบหน้าในการเรียนของพนักงาน
                                    </Link>
                                    <Link 
                                        to="/backend/uploadEmployeeData" 
                                        onClick={handleMenuItemClick}  // Add click handler
                                        style={{
                                            display: 'block',
                                            padding: '8px 16px',
                                            textDecoration: 'none',
                                            color: 'black'
                                        }}
                                    >
                                        นำเข้าข้อมูลพนักงาน
                                    </Link>
                                    <Link 
                                        to="/backend/uploadCatalog" 
                                        onClick={handleMenuItemClick}  // Add click handler
                                        style={{
                                            display: 'block',
                                            padding: '8px 16px',
                                            textDecoration: 'none',
                                            color: 'black'
                                        }}
                                    >
                                        อัปโหลดไฟล์รายการสินค้า (PDF)
                                    </Link>
                                </div>
                            )}

                            
                            <button 
                                onClick={() => navigate('/users/change-password')}
                                className="dropdown-button"
                            >
                                เปลี่ยนรหัสผ่าน
                            </button>
                            <button 
                                onClick={handleLogout}
                                className="dropdown-button"
                            >
                                ออกจากระบบ
                            </button>
                        </div>
                    )}
                </div>
                <div id="profile-menu-name" style={{float: 'right', marginTop: '8px', marginRight: '10px'}}>
                    <span>{user.firstname} {user.lastname}</span>
                </div>
                <div style={{clear: 'both'}}></div>
            </div>
            <div className="header-profile-menu">
                {catalogFile && (
                    <a href={`${process.env.REACT_APP_API_URL}/uploads/${catalogFile}`} 
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '200px',
                            padding: '8px 0',
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            borderRadius: '8px',
                            color: 'white',
                            textDecoration: 'none',
                            transition: 'all 0.3s ease',
                            boxShadow: '0 4px 15px rgba(102, 126, 234, 0.2)',
                            margin: '0 15px'
                        }}
                        onMouseOver={(e) => {
                            e.currentTarget.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.4)';
                            e.currentTarget.style.filter = 'brightness(1.1)';
                        }}
                        onMouseOut={(e) => {
                            e.currentTarget.style.boxShadow = '0 4px 15px rgba(102, 126, 234, 0.2)';
                            e.currentTarget.style.filter = 'brightness(1)';
                        }}
                        target="_blank" 
                        rel="noopener noreferrer">
                        <img 
                            src="/images/catalog.png" 
                            alt="Catalog"
                            style={{
                                width: '20px',
                                height: '20px',
                                objectFit: 'contain',
                                filter: 'brightness(0) invert(1)',  // Makes the icon white
                                marginRight: '6px'
                            }}
                        />
                        <span style={{
                            fontSize: '14px',
                            fontWeight: '600',
                            whiteSpace: 'nowrap'
                        }}>
                            รายการสินค้า
                        </span>
                    </a>
                )}
            </div>
        </div>
    );
};

export default Header;